import config from '@/config'
import { store } from '@/store/store'
import axios from 'axios'

const instance = () =>
  axios.create({
    baseURL: `${config.serverUrl}api/tcp`,
    timeout: 30000,
    headers: {
      AUTHORIZATION: store.getters.securityToken
    }
  })

const tcpApi = {
  getShopPageWithMasterPageId: (request) => {
    const { master_page_id } = request
    return instance().get(`/${master_page_id}/sub-pages`)
  },
  postGetShopPageWithMasterPageId: (request) => {
    const { data, master_page_id } = request
    return instance().post(`/${master_page_id}/sub-pages/category`, data)
  },
  postCreateShopPage: (request) => {
    const { data, master_page_id } = request
    return instance().post(`/${master_page_id}/sub-page/category`, data)
  },
  putUpdateShopPage: (request) => {
    const { data, master_page_id } = request
    return instance().put(`/${master_page_id}/sub-page/category`, data)
  },
  deleteShopPage: (request) => {
    const { page_id, master_page_id } = request
    return instance().delete(`/${master_page_id}/sub-page/category`, {
      params: {
        page_id
      }
    })
  },
  postGetBusinessSummaryChart: (request) => {
    const { data } = request
    return instance().post(`/business-summary`, data)
  },
  postGetBusinessSummaryProductList: (request) => {
    const { data } = request
    return instance().post(`/business-summary/products`, data)
  },
  postGetOrderSummary: (request) => {
    const { data } = request
    return instance().post(`/order-summary`, data)
  },
  postGetOrderSummaryStatus: (request) => {
    const { data } = request
    return instance().post(`/order-summary/status`, data)
  },
  postGetOrderStatistics: (request) => {
    const { data } = request
    return instance().post(`/order-statistics`, data)
  },
  getBroadcast: (request) => {
    const { params } = request
    return instance().get('/broadcast/summary', {
      params
    })
  },
  getMemberLevel: (request) => {
    const { params } = request
    return instance().get('/member_level', {
      params
    })
  }
}
export default tcpApi



// WEBPACK FOOTER //
// ./src/api/tcp.js